<template>
  <div>
    <div class="shadow" v-show="ispreorder">
      <div class="preordercode">
        <div class="close" @click="closepreorder"></div>
        <div class="codebg"></div>
        <div class="codet">扫描微信二维码</div>
        <div class="codedet">了解预订详情</div>
      </div>
    </div>
    <div class="quicknav">
      <div
        class="qnlist"
        v-for="(nav, index) in navs"
        :key="index"
        :class="{ qnactive: nav.isactive }"
        @mouseover="nav.isactive = true"
        @mouseleave="nav.isactive = currentnav == index"
        @click="scrollto(nav.navid)"
      >
        {{ nav.isactive ? nav.name : '' }}
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img src="/static/img/p1-ch.jpg" width="100%" alt="蓝鲨 R 系列" />
      </div>
      <div class="text t1">
        <div class="fs_big t1_1 aniel" :class="{ ani: ani.a1 }">
          蓝鲨 R 系列
        </div>
        <div class="color_gray t1_2 aniel" :class="{ ani1: ani.a1 }">
          智能电动摩托车
        </div>
        <div class="fs_normal aniel t1_3" :class="{ ani2: ani.a1 }">
          有动力 更有智力
        </div>
        <!-- <div class="t1_4 aniel" :class="{ani3: ani.a1}">
          <div class="t1_robor t1_rob"><span>¥</span> <span class="fs_middle color_theme">9988</span><br/>蓝鲨 R1<span class="robor_xing1">*</span></div>
          <div class="t1_roborlite t1_rob"><span>¥</span> <span class="fs_middle color_theme">7988</span><br/>蓝鲨 R1 lite<span class="robor_xing2">*</span></div>
        </div>
        <div class="t1_new fs_tiny color_gray aniel" :class="{ani4: ani.a1}">* 上述价格不含锂电池包</div> -->
        <div class="t1_5 aniel" :class="{ ani5: ani.a1 }" @click="preorder">
          <button>在线预订</button>
        </div>
        <div
          class="fs_sub t1_6 color_theme aniel"
          :class="{ ani6: ani.a1 }"
          @click="checkconfig"
        >
          配置对比
        </div>
      </div>
      <div class="text t1a" id="a2">
        <div class="t1a_top">
          <div>
            <div class="t1a_t">
              <span :class="{ aniel: true, ani: ani.a2 }">
                <span class="fs_huge">110</span> km
              </span>
            </div>
            <div>
              <span class="color_gray aniel" :class="{ ani1: ani.a2 }">
                NEDC 续航⾥程
              </span>
            </div>
          </div>
          <div>
            <div class="t1a_t">
              <span class="t1a_1" :class="{ aniel: true, ani: ani.a2 }">
                <span class="fs_huge">80</span> km/h
              </span>
            </div>
            <div>
              <span class="color_gray aniel" :class="{ ani1: ani.a2 }">
                最高速度
              </span>
            </div>
          </div>
          <div>
            <div class="t1a_t">
              <span class="t1a_1" :class="{ aniel: true, ani: ani.a2 }">
                <span class="fs_normal">动⼒ + 系统控制域</span>
              </span>
            </div>
            <div>
              <span class="color_gray aniel" :class="{ ani1: ani.a2 }">
                汽⻋级双域智能中控系统
              </span>
            </div>
          </div>
          <div>
            <div class="t1a_t">
              <span class="t1a_1" :class="{ aniel: true, ani: ani.a2 }">
                <span class="fs_normal">ArkRide</span>
                <span class="fs_normal">OS 2.0</span>
              </span>
            </div>
            <div>
              <span class="color_gray aniel" :class="{ ani1: ani.a2 }">
                蓝鲨⻋载智能操作系统
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Robor -->
    <div class="page" id="n1" v-show="false">
      <div class="pic">
        <img
          src="/static/img/p2.jpg"
          width="100%"
          alt="蓝鲨 R 系列 智能电动摩托车"
        />
      </div>
      <div class="text t2" id="a3">
        <div class="aniel" :class="{ ani: ani.a3 }">
          <img src="/static/img/Robor.png" width="130px" alt="" />
        </div>
        <div class="fs_normal content aniel t2_2" :class="{ ani1: ani.a3 }">
          一台运用汽车科技创造的<br />智能电动摩托车
        </div>
      </div>
    </div>
    <!-- 动力 -->
    <div class="page" id="n2">
      <swiper3 ref="swiper3"></swiper3>
      <div class="text normalt t3a" id="a31">
        <div class="fs_big t3_1 aniel" :class="{ ani: ani.a31 }">
          汹涌<span class="fs_big color_theme">动力</span> 澎湃前行
        </div>
        <div class="fs_normal color_gray t3_2 aniel" :class="{ ani1: ani.a31 }">
          汽车级高速电机 扭矩大功率足
        </div>
      </div>
    </div>
    <div class="page" id="s4">
      <swiper4></swiper4>
      <div class="text t4" id="a4">
        <div class="fs_big1 title aniel" :class="{ ani: ani.a4 }">
          前后协力 左右同心
        </div>
        <div class="content aniel" :class="{ ani1: ani.a4 }">
          骑车快，刹车更快。CBS
          前后联动双碟刹系统高效缩短制动距离，拉动左右任意一侧制动手柄，前后轮碟刹器随即同时进入工作状态，均衡分配制动力，在高效减速的同时不失平稳。
        </div>
      </div>
    </div>
    <!-- 操控 -->
    <div class="page" id="n3">
      <div class="pic">
        <img
          src="/static/img/p5.jpg"
          width="100%"
          alt="蓝鲨 R 系列汽车级电机控制器"
        />
      </div>
      <div class="text t5" id="a5">
        <div class="fs_big t5_1 aniel" :class="{ ani: ani.a5 }">
          全面布<span class="color_theme fs_big">控</span> 车随心动
        </div>
        <div class="fs_normal color_gray t5_2 aniel" :class="{ ani1: ani.a5 }">
          汽车级电机控制器 五种模式自由骑行
        </div>
        <div class="content aniel" :class="{ ani2: ani.a5 }">
          为了充分发挥边挂电机的强大性能，我们为蓝鲨 R
          系列装载汽车级大功率电机控制器，其架构设计、节能化、轻量化和品质均达到汽车级标准。在弱磁控制和电流前馈控制算法的加持下，辅以
          FOC 矢量控制系统的调节，SVPWM
          空间矢量脉宽调制系统精确输出控制信号，使整车在保证平顺驾驶体验的同时，突破动力系统性能的边界。
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img src="/static/img/p6.jpg" width="100%" alt="蓝鲨 R 系列六挡行车" />
      </div>
      <div class="text t6" id="a6">
        <div class="fs_big1 title aniel" :class="{ ani: ani.a6 }">
          五种模式 一触即得
        </div>
        <div class="content aniel" :class="{ ani1: ani.a6 }">
          蓝鲨 R 系列智能摩托⻋⽀持五种行车模式，<br />
          包括 Normal、Eco、Sport 三个常规⾏⻋模式， 还有 MAM 和 Turbo
          竞速模式*。<br />
          在电机控制器的精准调节下，<br />
          蓝鲨 R 系列同时支持在任意速度下实现汽车级定速巡航，<br />
          让骑乘用户尽享如呼吸般自由舒适的驾驶体验。
        </div>
      </div>
      <div class="text t6a" id="a33">
        <div class="fs_tiny color_gray aniel" :class="{ ani: ani.a33 }">
          * 仅在双电池包同时运行且剩余电量均大于 20% 的状态下可触发
        </div>
      </div>
    </div>
    <!-- 续航 -->
    <div class="page" id="n4">
      <div class="pic">
        <img
          src="/static/img/p7.jpg"
          width="100%"
          alt="蓝鲨 R 系列双锂电 支持160km续航"
        />
      </div>
      <div class="text t7" id="a7">
        <div class="t7_left">
          <div class="fs_big t7_1 aniel" :class="{ ani: ani.a7 }">
            双<span class="fs_big color_theme">电</span>齐下 源源不断
          </div>
          <div
            class="fs_normal color_gray t7_2 aniel"
            :class="{ ani1: ani.a7 }"
          >
            汽车级双锂电 持久续航电压倍增
          </div>
          <div class="content aniel" :class="{ ani2: ani.a7 }">
            蓝鲨 R 系列的座桶内可容纳两颗汽⻋级⾼能量密度锂电池包（48V / 30Ah ×
            2），常规骑⾏状态下可保证 110 km 的 NEDC
            续航⾥程。防摔防刺⼀体成型铝合⾦外桶的防⽕阻燃和散热性能得到⼤幅提升，保障电池在极端条件下安全⽆虞。
          </div>
          <!-- <div class="t7_4 aniel" :class="{ani3: ani.a7}">
            <span class="color_gray">￥<span class="fs_big color_theme">5988</span> / 双电</span>
          </div> -->
        </div>
        <div class="t7_right">
          <div class="t7_3 aniel" :class="{ ani: ani.a7 }">
            <span class="fs_middle">2,880</span> Wh<br /><span class="fs_tiny">
              双锂电池容量
            </span>
          </div>
          <div class="t7_3 aniel" :class="{ ani1: ani.a7 }">
            <span class="fs_middle">110</span> km<br /><span class="fs_tiny">
              NEDC 续航⾥程
            </span>
          </div>
          <div class="aniel" :class="{ ani2: ani.a7 }">
            <span class="fs_middle">&lt; 3.5</span> h<br /><span
              class="fs_tiny"
            >
              单电池快充时⻓
            </span>
          </div>
        </div>
      </div>
      <div id="a8" class="text t7a">
        <!-- <div class="fs_tiny aniel" :class="{ani: ani.a8}">*在骑乘者体重 75 kg，行驶速度 30 km/h，环境温度为 25℃ 等实验室条件下计算所得理论数据</div> -->
      </div>
    </div>
    <div class="page">
      <div class="t8">
        <div id="a9" class="title fs_big1 aniel" :class="{ ani: ani.a9 }">
          BMS 智能电源管理系统
        </div>
        <div class="t8a">
          <div class="t8a_item">
            <div id="a10" class="t8a_1 color_gray">
              <span class="aniel" :class="{ ani: ani.a10 }"
                ><img
                  src="/static/img/p8-11.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a10 }"
                >预放电</span
              >
            </div>
            <div id="a11" class="t8a_1 color_gray">
              <span class="aniel" :class="{ ani: ani.a11 }"
                ><img
                  src="/static/img/p8-21.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a11 }"
                >强弱电隔离保护</span
              >
            </div>
            <div id="a12" class="color_gray">
              <span class="aniel" :class="{ ani: ani.a12 }"
                ><img
                  src="/static/img/p8-31.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a12 }"
                >过充保护</span
              >
            </div>
          </div>
          <div class="t8a_item">
            <div class="t8a_1 color_gray">
              <span class="aniel" :class="{ ani: ani.a10 }"
                ><img
                  src="/static/img/p8-12.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a10 }"
                >电压均衡</span
              >
            </div>
            <div class="t8a_1 color_gray">
              <span class="aniel" :class="{ ani: ani.a11 }"
                ><img
                  src="/static/img/p8-22.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a11 }"
                >进水保护</span
              >
            </div>
            <div class="color_gray">
              <span class="aniel" :class="{ ani: ani.a12 }"
                ><img
                  src="/static/img/p8-32.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a12 }"
                >过放保护</span
              >
            </div>
          </div>
          <div class="t8a_item">
            <div class="t8a_1 color_gray">
              <span class="aniel" :class="{ ani: ani.a10 }"
                ><img
                  src="/static/img/p8-13.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a10 }"
                >充放电循环次数统计</span
              >
            </div>
            <div class="t8a_1 color_gray">
              <span class="aniel" :class="{ ani: ani.a11 }"
                ><img
                  src="/static/img/p8-23.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a11 }"
                >断线保护</span
              >
            </div>
            <div class="color_gray">
              <span class="aniel" :class="{ ani: ani.a12 }"
                ><img
                  src="/static/img/p8-33.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a12 }"
                >非接触式通讯</span
              >
            </div>
          </div>
          <div class="t8a_item">
            <div class="t8a_1 color_gray">
              <span class="aniel" :class="{ ani: ani.a10 }"
                ><img
                  src="/static/img/p8-14.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a10 }"
                >双电池放电管理</span
              >
            </div>
            <div class="t8a_1 color_gray">
              <span class="aniel" :class="{ ani: ani.a11 }"
                ><img
                  src="/static/img/p8-24.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a11 }"
                >短路保护</span
              >
            </div>
            <div class="color_gray">
              <span class="aniel" :class="{ ani: ani.a12 }"
                ><img
                  src="/static/img/p8-34.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a12 }"
                >电池故障二次保护</span
              >
            </div>
          </div>
          <div class="t8a_item">
            <div class="t8a_1 color_gray">
              <span class="aniel" :class="{ ani: ani.a10 }"
                ><img
                  src="/static/img/p8-15.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a10 }"
                >双电池充电管理</span
              >
            </div>
            <div class="t8a_1 color_gray">
              <span class="aniel" :class="{ ani: ani.a11 }"
                ><img
                  src="/static/img/p8-25.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a11 }"
                >过流保护</span
              >
            </div>
            <div class="color_gray">
              <span class="aniel" :class="{ ani: ani.a12 }"
                ><img
                  src="/static/img/p8-35.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a12 }"
                >温度保护</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img src="/static/img/p9.jpg" width="100%" alt="蓝鲨电压倍增技术" />
      </div>
      <div class="text normalt" id="a13">
        <div class="title fs_big1 aniel" :class="{ ani: ani.a13 }">
          乘奔御风 急速骑行
        </div>
        <div class="content aniel" :class="{ ani1: ani.a13 }">
          蓝鲨技术团队自主研发电压倍增技术，并联状态下均衡输出电流，串联状态下触发双倍电压，后者即
          Turbo 竞速挡* 的高速行车模式。<br />这项技术是电源管理系统技术上的重大突破，同时为行业指明发展方向。
        </div>
      </div>
      <div id="a32" class="text t9a">
        <div class="fs_tiny color_gray aniel" :class="{ ani: ani.a32 }">
          * 仅在双电池包同时运行且剩余电量均大于 20% 的状态下可触发
        </div>
      </div>
    </div>
    <div class="page">
      <swiper10></swiper10>
      <div class="text normalt" id="a14">
        <div class="title fs_big1 aniel" :class="{ ani: ani.a14 }">
          多场景快充
        </div>
        <div class="content aniel" :class="{ ani1: ani.a14 }">
          蓝鲨 R
          系列支持在各种环境下进行充电——无论是家庭用电环境还是电动车充电环境。<br />单颗电池最快仅需
          3.5 小时即可充满，从此无需再为续航烦恼。
        </div>
      </div>
    </div>
    <!-- 设计 -->
    <div class="page" id="n5">
      <swiper11></swiper11>
      <div class="text t11" id="a15">
        <div class="fs_big aniel" :class="{ ani: ani.a15 }">
          独树一帜 <span class="fs_big color_theme">蔚</span>然成风
        </div>
        <div
          class="fs_normal color_gray t15_2 aniel"
          :class="{ ani1: ani.a15 }"
        >
          汽车级工业设计 自由而严谨 简洁而醒目
        </div>
      </div>
    </div>
    <!-- 品质 -->
    <div class="page" id="n6">
      <div class="pic">
        <img
          src="/static/img/p12-ch.jpg"
          width="100%"
          alt="蓝鲨 R 系列与贝纳利摩托共厂生产制造|顶级供应链合作伙伴|整车承重 200 kg"
        />
      </div>
      <div class="text normalt" id="a16">
        <div class="title fs_big aniel" :class="{ ani: ani.a16 }">
          匠心独运 精益求<span class="fs_big color_theme">精</span>
        </div>
        <div class="content aniel" :class="{ ani1: ani.a16 }">
          蓝鲨 R
          系列的车架、壳体、灯具、减震、刹车、轮胎等核心部件，均与全球知名摩托车品牌的供应方合作，<br />以竞赛级摩托的工艺和品控标准精心打磨智能电动摩托车
        </div>
      </div>
      <div class="text t12" id="a34">
        <div class="fs_tiny t12_1 aniel" :class="{ ani: ani.a34 }">
          国内一线大型摩托车厂生产制造
        </div>
        <div class="fs_tiny t12_2 aniel" :class="{ ani: ani.a34 }">
          顶级供应链合作伙伴
        </div>
        <div class="fs_tiny t12_3 aniel" :class="{ ani: ani.a34 }">
          整车承重 200 kg
        </div>
      </div>
    </div>
    <!-- 智能 -->
    <div class="page" id="n7">
      <div class="pic">
        <img src="/static/img/p13.jpg" width="100%" alt="蓝鲨 R 系列汽车科技" />
      </div>
      <div class="text normalt" id="a17">
        <div class="title fs_big aniel" :class="{ ani: ani.a17 }">
          汽车科技 <span class="fs_big color_theme">智</span>能降临
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img
          src="/static/img/p14.jpg"
          width="100%"
          alt="蓝鲨 R 系列智能中控系统"
        />
      </div>
      <div class="text normalt" id="a18">
        <div class="title fs_big1 aniel" :class="{ ani: ani.a18 }">
          汽⻋级「动⼒控制域 + 系统控制域」智能中控系统
        </div>
        <div class="content aniel" :class="{ ani1: ani.a18 }">
          蓝鲨⾃主研发的汽⻋级智能中控系统，通过 4G
          通信模块接⼊蓝鲨⻋联⽹云后台，动⼒控制域可以实时监控和智能调控驾驶状态，系统控制域负责整⻋⼈机交互。<br />
          得益于 CAN
          总线协议优势，整⻋的功能扩展性⼤幅增强，可顺利实现添加其他功能模组的定制化需求。
        </div>
      </div>
    </div>
    <div class="page">
      <swiper15></swiper15>
      <div class="text normalt" id="a19">
        <div class="title fs_big1 aniel" :class="{ ani: ani.a19 }">
          全彩⾼亮⾼清 IPS 仪表屏
        </div>
        <div class="content aniel" :class="{ ani1: ani.a19 }">
          蓝鲨 R1 搭载 G+G 全贴合 10 英⼨全彩⾼亮⾼清 IPS 仪表屏，搭载蓝鲨⾃研的
          ArkRide OS 2.0 智能⻋机系统，<br />⽀持 GPS + 北⽃ + 4G
          三模定位、蓝⽛导航、蓝⽛⾳乐、OTA
          升级等功能，带来灵敏⽽便捷的智能操控体验
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img
          src="/static/img/p16.jpg"
          width="100%"
          alt="蓝鲨 R 系列AI里程预估"
        />
      </div>
      <div class="text normalt" id="a20">
        <div class="title fs_big1 aniel" :class="{ ani: ani.a20 }">
          AI 里程预估
        </div>
        <div class="content aniel" :class="{ ani1: ani.a20 }">
          综合剩余电量、环境温度、行驶速度和整车重量等参数，蓝鲨 R
          系列在云端和本地实时进行动态计算，为你显示当前行驶状态下的剩余里程。
        </div>
      </div>
    </div>
    <div class="page">
      <div class="lisablack hp0" id="a21">
        <!-- <div class="title fs_big1 aniel" :class="{ani: ani.a21}">「你好, Lisa」</div>
        <div class="content aniel" :class="{ani1: ani.a21}">和智能骑行伴侣 Lisa 打个招呼，定向收音麦克风确保你的讯息准确无误传达。<br/>一句「你好, Lisa」,让你的旅程不再孤独。</div> -->
      </div>
      <div class="pic">
        <!-- <video src="/static/img/lisa.mp4" width="100%" autoplay="autoplay" loop="loop" muted="muted"></video> -->
      </div>
    </div>
    <!-- <div class="page">
      <div class="lisablack" id="a21">
        <div class="title fs_big1 aniel" :class="{ani: ani.a21}">「你好, Lisa」</div>
        <div class="content aniel" :class="{ani1: ani.a21}">和智能骑行伴侣 Lisa 打个招呼，定向收音麦克风确保你的讯息准确无误传达。<br/>一句「你好, Lisa」,让你的旅程不再孤独。</div>
      </div>
      <div class="pic">
        <video src="/static/img/lisa.mp4" width="100%" autoplay="autoplay" loop="loop" muted="muted"></video>
      </div>
    </div> -->
    <div class="page">
      <div class="pic">
        <img src="/static/img/p17.jpg" width="100%" alt="Blueshark APP" />
      </div>
      <div class="text normalt" id="a22">
        <div class="title fs_big1 aniel" :class="{ ani: ani.a22 }">
          蓝鲨 App
        </div>
        <div class="content aniel" :class="{ ani1: ani.a22 }">
          车辆信息实时与云端交互，并同步到手机 App 中。<br />定位查询、远程控制、行车统计、电池检测、整车体检，随时一手掌握。
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img
          src="/static/img/p18-ch.jpg"
          width="100%"
          alt="蓝鲨 R 系列配备72枚传感器"
        />
      </div>
      <div class="text normalt" id="a23">
        <div class="title fs_big1 aniel" :class="{ ani: ani.a23 }">
          70+ 枚传感器
        </div>
        <div class="content aniel" :class="{ ani1: ani.a23 }">
          70+
          枚传感器遍布⻋身，随时采集包括速度、加速度、角速度、温度、环境光、水位和座椅压力等多重骑行信息，<br />为整车智能提供数据支持，帮助蓝鲨
          R 系列保持最佳的行驶状态。
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img
          src="/static/img/p19.jpg"
          width="100%"
          alt="蓝鲨 R 系列双向移车助力"
        />
      </div>
      <div class="text normalt" id="a24">
        <div class="title fs_big1 aniel" :class="{ ani: ani.a24 }">
          移⻋助⼒模式 (MAM)
        </div>
        <div class="content aniel" :class="{ ani1: ani.a24 }">
          当⽤户进⼊移⻋助⼒模式时，转动转把或向左拨动模式切换按键，提供步⾏速度向前移动；<br />
          向右拨动模式切换按键，⻋辆缓速向后移动。<br />
          便捷操作助⼒轻松移⻋。
        </div>
      </div>
    </div>
    <div class="page">
      <swiper20></swiper20>
      <div class="text normalt" id="a25">
        <div class="title fs_big1 aniel" :class="{ ani: ani.a25 }">
          ADAS 安全驾驶辅助系统
        </div>
        <div class="content aniel" :class="{ ani1: ani.a25 }">
          汽车级 ADAS
          智能驾驶辅助系统实时监控行车状况，通知提醒可实时呈现在车载屏幕上，<br />用户也可以通过移动端
          App 随时调用相关信息。
        </div>
      </div>
    </div>
    <!-- 安全 -->
    <div class="page" id="n8">
      <swiper21 ref="swiper21"></swiper21>
      <div class="text normalt" id="a26">
        <div class="fs_big aniel" :class="{ ani: ani.a26 }">
          千方百计 万无一失
        </div>
        <div
          class="fs_normal color_gray t21_2 aniel"
          :class="{ ani1: ani.a26 }"
        >
          全⽅位安全保障 汽⻋级蓝⽛智能钥匙系统+⽆感⾃动撤防解锁
        </div>
      </div>
    </div>
    <div class="page" id="s22">
      <swiper22 ref="swiper22"></swiper22>
    </div>
    <div class="page" id="s23">
      <swiper23 ref="swiper23"></swiper23>
    </div>
    <div class="page p24">
      <div id="a27">
        <div class="title fs_big1 aniel" :class="{ ani: ani.a27 }">
          技术参数
        </div>
        <div class="t24p aniel" :class="{ ani1: ani.a27 }">
          <div>
            <img
              src="../../../static/img/p24-1-ch.png"
              width="100%"
              alt="蓝鲨 R 系列技术参数"
            />
          </div>
        </div>
        <div class="t24">
          <div class="feature" id="a28">
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a28 }">
                额定最大承载重量
              </span>
              <br />
              <span class="aniel" :class="{ ani1: ani.a28 }">
                200 kg
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a28 }">
                车体重量（含电池）
              </span>
              <br />
              <span class="aniel" :class="{ ani1: ani.a28 }">115 kg</span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a28 }">
                车身颜色
              </span>
              <br />
              <span class="aniel" :class="{ ani1: ani.a28 }">
                秋月白；云墨黑；绿如蓝；松涛绿；椰林棕
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a28 }">
                启动方式
              </span>
              <br />
              <span class="aniel" :class="{ ani1: ani.a28 }">
                蓝牙感应
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a28 }">
                中控仪表屏
              </span>
              <br />
              <span class="aniel" :class="{ ani1: ani.a28 }">
                10'' 高亮高清全彩 IPS 屏
              </span>
            </div>
          </div>
          <div class="feature" id="a29">
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a29 }">
                智能操作系统
              </span>
              <br /><span class="aniel" :class="{ ani1: ani.a29 }">
                ArkRide OS
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a29 }">
                电池容量
              </span>
              <br /><span class="aniel" :class="{ ani1: ani.a29 }">
                1,440*2 Wh
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a29 }">
                NEDC 续航里程
              </span>
              <br /><span class="aniel" :class="{ ani1: ani.a29 }">
                110 km
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a29 }">
                最高速度
              </span>
              <br /><span class="aniel" :class="{ ani1: ani.a29 }">
                80 km/h
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a29 }">
                电机峰值功率 </span
              ><br /><span class="aniel" :class="{ ani1: ani.a29 }">
                5,000W
              </span>
            </div>
          </div>
          <div class="feature" id="a30">
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a30 }">
                电机最高转速
              </span>
              <br /><span class="aniel" :class="{ ani1: ani.a30 }">
                5,500 rpm
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a30 }">
                智能中控系统
              </span>
              <br /><span class="aniel" :class="{ ani1: ani.a30 }">
                动力+系统控制域
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a30 }">
                ADAS 智能驾驶辅助系统
              </span>
              <br /><span class="aniel" :class="{ ani1: ani.a30 }">
                后摄像头+双超声探头<br />（前摄像头选装）
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a30 }">
                刹车系统
              </span>
              <br /><span class="aniel" :class="{ ani1: ani.a30 }">
                CBS 前后同步双碟刹
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a30 }">
              </span>
              <br /><span class="aniel" :class="{ ani1: ani.a30 }"></span>
            </div>
            <!-- <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ani: ani.a30}">语音助手</span><br/><span class="aniel" :class="{ani1: ani.a30}">Lisa 骑行伴侣</span></div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swiper3 from '../swiper/swiper3'
import swiper4 from '../swiper/swiper4'
import swiper10 from '../swiper/swiper10'
import swiper11 from '../swiper/swiper11'
import swiper15 from '../swiper/swiper15'
import swiper20 from '../swiper/swiper20'
import swiper21 from '../swiper/swiper21'
import swiper22 from '../swiper/swiper22'
import swiper23 from '../swiper/swiper23'
import { throttle } from 'lodash'
export default {
  data() {
    return {
      ani: {
        a1: false,
        a2: false,
        a3: false,
        a4: false,
        a5: false,
        a6: false,
        a7: false,
        a8: false,
        a9: false,
        a10: false,
        a11: false,
        a12: false,
        a13: false,
        a14: false,
        a15: false,
        a16: false,
        a17: false,
        a18: false,
        a19: false,
        a20: false,
        a21: false,
        a22: false,
        a23: false,
        a24: false,
        a25: false,
        a26: false,
        a27: false,
        a28: false,
        a29: false,
        a30: false,
        a31: false,
        a32: false,
        a33: false,
        a34: false
      },
      navs: [
        { name: 'R 系列', isactive: false, navid: 'n1' },
        { name: '动力', isactive: false, navid: 'n2' },
        { name: '操控', isactive: false, navid: 'n3' },
        { name: '续航', isactive: false, navid: 'n4' },
        { name: '设计', isactive: false, navid: 'n5' },
        { name: '品质', isactive: false, navid: 'n6' },
        { name: '智能', isactive: false, navid: 'n7' },
        { name: '安全', isactive: false, navid: 'n8' }
      ],
      currentnav: -1,
      ispreorder: false
      // aniarr: ["a1","a2","a3"]
    }
  },
  components: {
    swiper3,
    swiper4,
    swiper10,
    swiper11,
    swiper15,
    swiper20,
    swiper21,
    swiper22,
    swiper23
  },
  mounted() {
    window.scrollTo(0, 0)
    this.$nextTick(() => {
      window.addEventListener(
        'scroll',
        throttle(this.animateTxt, 500, { leading: true })
      )
    })
    setTimeout(() => {
      this.ani.a1 = true
    }, 300)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.animateTxt)
  },
  methods: {
    preorder() {
      this.ispreorder = true
    },
    closepreorder() {
      this.ispreorder = false
    },
    checkconfig() {
      this.$router.push('/cn/R1config')
    },
    getscrolltop(id) {
      let obj = document.getElementById(id)
      if (obj) {
        let top = obj.offsetTop
        while ((obj = obj.offsetParent)) {
          top += obj.offsetTop
        }
        return top
      }
    },
    scrollto(id) {
      window.scrollTo(0, this.getscrolltop(id))
    },
    setnavs() {
      for (let i in this.navs) {
        this.navs[i].isactive = false
      }
    },
    animateTxt() {
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset
      // let width = document.body.clientWidth
      let height = document.body.clientHeight
      if (top <= 100) {
        this.$emit('hidenav')
      } else {
        this.$emit('shownav')
      }
      // 左侧快速导航
      for (let i = 0; i < 9; i++) {
        let prev = i > 0 ? this.getscrolltop('n' + i) : 0
        let next = i < 8 ? this.getscrolltop('n' + (i + 1)) : 1000000
        if (top >= prev && top < next) {
          this.setnavs()
          if (i > 0) {
            this.navs[i - 1].isactive = true
          }
          this.currentnav = i - 1 // 锁定当前页
          break
        }
      }
      // 每一页文字出现特效
      for (let i = 2; i < 35; i++) {
        if (
          top > this.getscrolltop('a' + i) - height + 200 &&
          top < this.getscrolltop('a' + i)
        ) {
          this.ani['a' + i] = true
        }
      }
      if (
        top > this.getscrolltop('n2') - height + 200 &&
        top < this.getscrolltop('n2')
      ) {
        if (this.$refs.swiper3) {
          this.$refs.swiper3.startani1()
        }
      }
      if (
        top > this.getscrolltop('s4') - height &&
        top < this.getscrolltop('s4') - 300
      ) {
        if (this.$refs.swiper3) {
          this.$refs.swiper3.startani2()
        }
      }
      if (
        top > this.getscrolltop('n8') - height + 200 &&
        top < this.getscrolltop('n8')
      ) {
        if (this.$refs.swiper21) {
          this.$refs.swiper21.startani()
        }
      }
      if (
        top > this.getscrolltop('s22') - height + 200 &&
        top < this.getscrolltop('s22')
      ) {
        if (this.$refs.swiper22) {
          this.$refs.swiper22.startani()
        }
      }
      if (
        top > this.getscrolltop('s23') - height + 200 &&
        top < this.getscrolltop('s23')
      ) {
        if (this.$refs.swiper23) {
          this.$refs.swiper23.startani()
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/common.less';
.subscript {
  display: inline-block;
  font-size: 10px;
  vertical-align: top;
  position: relative;
  top: -4px;
  transform: scale(0.8);
}
.quicknav {
  position: fixed;
  left: 0;
  top: 30vh;
  color: #fff;
  z-index: 100;
  .qnlist {
    padding-left: 40px;
    position: relative;
    cursor: pointer;
    width: 150px;
    height: 30px;
  }
  .qnlist::before {
    position: absolute;
    content: '';
    width: 15px;
    height: 0;
    border-top: 1px solid #666;
    top: 10px;
    left: 15px;
  }
  .qnactive::before {
    position: absolute;
    content: '';
    width: 30px;
    height: 0;
    border-top: 1px solid #fff;
    top: 10px;
    left: 0;
  }
}
.shadow {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 300;
  .preordercode {
    padding-top: 40px;
    width: 340px;
    height: 300px;
    text-align: center;
    background: #fff;
    // background: url(/static/img/p28_1.jpg);
    // background-size: cover;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    .codebg {
      margin: 0 auto;
      width: 200px;
      height: 200px;
      background: url(/static/img/p28_1.jpg);
      background-size: cover;
    }
    .codet {
      color: #999;
      // padding: 5px 0 10px;
      margin-bottom: 10px;
    }
    .codedet {
      font-size: 24px;
    }
    .close {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
    }
    .close::before {
      content: '';
      position: absolute;
      top: 10px;
      left: -4px;
      width: 26px;
      height: 0;
      border-top: 1px solid #666;
      transform: rotate(45deg);
    }
    .close::after {
      content: '';
      position: absolute;
      top: 10px;
      left: -4px;
      width: 26px;
      height: 0;
      border-top: 1px solid #666;
      transform: rotate(-45deg);
    }
  }
}
.page {
  position: relative;
  background-color: #000;
  .pic {
    font-size: 0;
  }
  .lisablack {
    background-color: #000;
    height: 8vw;
    color: #fff;
    text-align: center;
    padding-top: 4vw;
  }
  .hp0 {
    height: 0;
    padding-top: 0;
  }
  .title {
    margin-bottom: 26px;
  }
  .content {
    line-height: 24px;
  }
  .content1 {
    line-height: 20px;
  }
  .text {
    position: absolute;
    z-index: 1;
    color: #fff;
  }
  .t1 {
    left: 20vw;
    top: 15vw;
    .t1_1 {
      margin-bottom: 10px;
    }
    .t1_2 {
      margin-bottom: 5px;
      letter-spacing: 3px;
    }
    .t1_3 {
      letter-spacing: 8px;
      margin-bottom: 15px;
    }
    .t1_4 {
      display: flex;
      display: -webkit-flex;
      margin-bottom: 20px;
      .t1_robor {
        font-size: 14px;
        padding-right: 20px;
        border-right: 1px solid #333;
      }
      .t1_roborlite {
        font-size: 14px;
        padding-left: 20px;
      }
      .t1_rob {
        position: relative;
        .robor_xing1 {
          right: 11px;
          position: absolute;
          top: 4px;
        }
        .robor_xing2 {
          position: absolute;
          right: -10px;
          top: 4px;
        }
      }
    }
    .t1_new {
      margin-bottom: 20px;
    }
    .t1_5 {
      margin: 40px 0 35px;
      button {
        width: 100%;
        height: 45px;
        border: 0;
        border-radius: 40px;
        outline: none;
        font-size: 16px;
        letter-spacing: 5px;
        text-indent: 5px;
        color: #fff;
        cursor: pointer;
        background: linear-gradient(to right, #00c5ff, #0073ff);
      }
    }
    .t1_6 {
      letter-spacing: 5px;
      display: inline;
      cursor: pointer;
    }
  }
  .t1a {
    bottom: 80px;
    margin: 0 auto;
    left: 0;
    right: 0;
    width: 70%;
    .t1a_top {
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      text-align: center;
      width: 100%;
      .t1a_t {
        height: 50px;
        line-height: 50px;
        vertical-align: text-bottom;
      }
      .subscript {
        position: relative;
        top: -5px;
        font-size: 14px;
      }
    }
    .t1a_bottom {
      width: 100%;
      color: #999;
      font-size: 12px;
      text-align: center;
      margin-top: 30px;
    }
  }
  .t2 {
    left: 18vw;
    top: 9vw;
    line-height: 60px;
    .t2_2 {
      line-height: 36px;
    }
  }
  .t3a {
    .t3_2 {
      margin: 15px auto 0;
    }
  }
  .t4 {
    left: 9vw;
    top: 15vw;
    width: 440px;
    text-align: justify;
  }
  .t5 {
    left: 12vw;
    top: 15vw;
    width: 410px;
    text-align: justify;
    .t5_1 {
      margin-bottom: 10px;
    }
    .t5_2 {
      margin-bottom: 20px;
    }
  }
  .normalt {
    top: 65px;
    left: 0;
    right: 0;
    margin: 0 auto;
    text-align: center;
  }
  .t6 {
    top: 22vw;
    left: 0;
    right: 0;
    margin: 0 auto;
    text-align: center;
  }
  .t6a {
    text-align: center;
    bottom: 5vw;
    width: 100%;
  }
  .t7 {
    left: 7vw;
    top: 11vw;
    right: 17vw;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    .t7_left {
      width: 400px;
      text-align: justify;
      padding-top: 2vw;
    }
    .t7_1 {
      margin-bottom: 10px;
    }
    .t7_2 {
      margin-bottom: 20px;
    }
    .t7_3 {
      margin-bottom: 40px;
    }
    .t7_4 {
      margin-top: 40px;
    }
  }
  .t7a {
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: 3vw;
    font-size: 10px;
    text-align: center;
    color: @colorgray;
  }
  .t8 {
    background-color: #000;
    color: #fff;
    text-align: center;
    padding: 4vw 0;
    .t8a {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      width: 60%;
      margin: 80px auto 0;
      .t8a_item {
        flex: 1;
      }
      img {
        width: 50px;
        margin-bottom: 10px;
      }
      .t8a_1 {
        margin-bottom: 50px;
        height: 90px;
      }
    }
  }
  .t9a {
    width: 100%;
    text-align: center;
    bottom: 5vw;
  }
  .t11 {
    left: 10vw;
    top: 160px;
  }
  .t12 {
    display: flex;
    display: -webkit-flex;
    left: 17vw;
    right: 17vw;
    bottom: 7.5vw;
    text-align: center;
    .t12_1 {
      width: 22vw;
    }
    .t12_2 {
      width: 21vw;
    }
    .t12_3 {
      flex: 1;
    }
  }
  .t15_2 {
    margin: 15px auto 10px;
  }
  .t21_2 {
    margin: 15px auto 15px;
  }
  .t24p {
    padding: 2vw 18vw;
  }
  .t24 {
    margin-top: 3vw;
    .feature {
      width: 80%;
      margin: 0 auto;
      border-top: 1px solid #333;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      padding: 2vw 3vw;
      box-sizing: border-box;
      .featureitem {
        flex: 1;
        text-align: left;
        line-height: 24px;
        margin-right: 10px;
        .aniel {
          font-size: 14px;
        }
        .subscript {
          display: inline-block;
          position: relative;
          top: -2px;
          transform: scale(0.8);
        }
        .fs_tiny {
          margin-bottom: 20px;
        }
      }
    }
    .csenv {
      text-align: center;
      font-size: 14px;
      color: #999;
    }
  }
}
.p24 {
  background: url(/static/img/p24.jpg) no-repeat;
  background-size: cover;
  color: #fff;
  padding-bottom: 2vw;
  .title {
    padding-top: 4vw;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cn/product.vue